module.exports = __webpack_public_path__ + "static/img/statusCorrectStaticChester.4096d191.png";